export const SET_CITIES = 'SET_CITIES';
export const SET_CITY = 'SET_CITY';
export const SET_UNIVERSITIES = 'SET_UNIVERSITIES';
export const SET_UNIVERSITY = 'SET_UNIVERSITY';
